export class TranslationError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'TranslationError';
  }
}
